export default {
  // Navigation
  'nav.timer': 'Cronómetro',
  'nav.stopwatch': 'Cronógrafo',
  'nav.worldclock': 'Reloj Mundial',
  'nav.timestamp': 'Marca de Tiempo',
  'nav.home': 'Inicio',

  // Common buttons and actions
  'button.start': 'Iniciar',
  'button.pause': 'Pausar',
  'button.stop': 'Detener',
  'button.reset': 'Reiniciar',
  'button.ok': 'Aceptar',
  'button.cancel': 'Cancelar',
  'button.close': 'Cerrar',
  'button.save': 'Guardar',
  'button.delete': 'Eliminar',
  'button.edit': 'Editar',
  'button.back': 'Volver',
  'button.confirm': 'Confirmar',
  'button.apply': 'Aplicar',
  'button.clear': 'Limpiar',
  'button.copy': 'Copiar',
  'button.download': 'Descargar',

  // Labels
  'label.language': 'Idioma',
  'label.selectLanguage': 'Seleccionar Idioma',
  'label.languageSelectorInfo': 'Actualmente admite {{count}} idiomas. Seleccione su idioma preferido de las opciones anteriores.',
  'label.time': 'Tiempo',
  'label.date': 'Fecha',
  'label.timezone': 'Zona Horaria',
  'label.duration': 'Duración',
  'label.fullscreen': 'Pantalla Completa',
  'label.settings': 'Configuración',
  'label.sound': 'Sonido',
  'label.volume': 'Volumen',

  // Units
  'unit.hours': 'Horas',
  'unit.minutes': 'Minutos',
  'unit.seconds': 'Segundos',
  'unit.milliseconds': 'Milisegundos',
  'unit.hour': 'Hora',
  'unit.minute': 'Minuto',
  'unit.second': 'Segundo',
  'unit.millisecond': 'Milisegundo',
  'unit.h': 'h',
  'unit.m': 'm',
  'unit.s': 's',
  'unit.ms': 'ms',

  // Messages
  'message.copied': '¡Copiado al portapapeles!',
  'message.error': 'Ha ocurrido un error',
  'message.success': 'Operación exitosa',
  'message.loading': 'Cargando...',
  'message.noData': 'Sin datos',
  'message.confirm': '¿Está seguro?',

  // Footer
  'footer.about': 'Acerca de',
  'footer.aboutDesc': 'timer.today es una herramienta online gratuita de gestión del tiempo que incluye cronómetro, cronógrafo y reloj mundial. Perfecta para productividad, estudio, cocina y planificación de viajes.',
  'footer.timerDesc': 'Cronómetro de cuenta regresiva personalizable con alertas de sonido',
  'footer.stopwatchDesc': 'Cronógrafo de alta precisión con funcionalidad de vueltas',
  'footer.worldClockDesc': 'Reloj en tiempo real que muestra la hora actual en ciudades de todo el mundo',
  'footer.termsOfService': 'Términos de Servicio',
  'footer.privacy': 'Política de Privacidad',
  'footer.contactUs': 'Contáctenos',
  'footer.copyright': '© 2025 timer.today - Herramienta de Cronómetro Online Gratuita',

  // Common phrases
  'common.free': 'Gratis',
  'common.online': 'En Línea',
  'common.tool': 'Herramienta',
  'common.tools': 'Herramientas',
  'common.features': 'Características',
  'common.support': 'Soporte',
  'common.help': 'Ayuda',
  'common.faq': 'Preguntas Frecuentes',
  'common.contact': 'Contacto',
  'common.share': 'Compartir',
  'common.popular': 'Popular',
  'common.new': 'Nuevo',
  'common.all': 'Todo'
};
